import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isBuyWindow: undefined,
  isClaimWindow: undefined,
  buyWindowEnds: 0,
  claimWindowEnds: 0,
  timeUntilBuyEnds: 0,
  timeUntilBuyOpens: 0,
  timeUntilClaimEnds: 0,
  timeUntilClaimOpens: 0,
};

const windowStatusSlice = createSlice({
  name: "windowStatus",
  initialState,
  reducers: {
    updateWindowStatus: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetWindowStatus: () => initialState,
  },
});

export const { updateWindowStatus, resetWindowStatus } = windowStatusSlice.actions;

export default windowStatusSlice.reducer;

